import packageInfo from '../../package.json';

export const environment = {
  production: false,
  version: packageInfo.version,
  apiCampaignsUrl:            'https://api.dev-wecheer.me/campaigns',
  apiRewardsUrl:              'https://api.dev-wecheer.me/rewards',
  apiBarManagementUrl:        'https://api.dev-wecheer.me/bar-management',
  apiUserManagementUrl:       'https://api.dev-wecheer.me/user-management',
  apiImageClassificationUrl:  'https://api.dev-wecheer.me/image-classification',
  apiDeviceManagementUrl:     'https://api.dev-wecheer.me/device-management',
  apiAccessManagementUrl:      'https://api.dev-wecheer.me/access-management',
  loyaltyAppUrl: 'https://dev-wecheer.me/loyalty',
  baseUrl: 'https://dev-wecheer.me/campaigns',
  authUrl: 'https://testwecheer.auth.ap-southeast-1.amazoncognito.com',
  clientId: '2mps70kvp987mvkjnifpvs0ou2',
  encryptionKey: "dev_AES256_7f9a2b4c8e6d1f3a5b7c9e2d4f6a8b0c3e5d7f9a1b3c5e7d9f1a3b5c7e9f1a3b",

  region: 'ap-southeast-1',
  userPoolId: 'ap-southeast-1_h8GFVAIow',

  userManagementUrl: 'https://dev-wecheer.me/user-management',
  accessManagementUrl: 'https://dev-wecheer.me/access-management',
  barManagementUrl: 'https://dev-wecheer.me/outlet-management',
  campaignManagementUrl: 'https://dev-wecheer.me/campaigns',
  coinsManagementUrl: 'https://dev-wecheer.me/coins',
  productsManagementUrl: 'https://dev-wecheer.me/products',
  consumptionManagementUrl: 'https://dev-wecheer.me/consumption',
  deviceManagementUrl: 'https://dev-wecheer.me/device-management',
  fraudDetectionManagementUrl: 'https://dev-wecheer.me/fraud-detection',
  imageClassificationManagementUrl: 'https://dev-wecheer.me/image-classification',
  rewardsManagementUrl: 'https://dev-wecheer.me/rewards',
  sboDistributionManagementUrl: 'https://dev-wecheer.me/catraca',
  acquisitionsManagementUrl: 'https://dev-wecheer.me/acquisitions',
  dashboardManagementUrl: 'https://dev-wecheer.me/dashboard',
  consentManagementUrl: 'https://dev-wecheer.me/consent-management',
  contentManagementUrl: 'https://dev-wecheer.me/content-management',
  observationManagementUrl: 'https://dev-wecheer.me/observation',
  billingManagementUrl: 'https://dev-wecheer.me/billing',
  clarity: {
    enabled: true,
    projectId: 'tmhl4791xs'
  },
};
